<template>
  <div>
    <div class="content">
      <div class="title-box">
        <h3 class="pull-left">{{CPACommDetailLan.datailText}}&nbsp;&nbsp;({{queryObj.REPORT_ID}})</h3>
        <div class="pull-right" style="margin-top:12px;">
          <el-button
            class="preview-btn"
            type="warning"
            round
            @click="$router.go(-1)"
          >{{CPACommDetailLan.goback}}</el-button>
        </div>
        <div class="clear"></div>
      </div>
      <div class="panel" v-loading="loading" element-loading-spinner="el-icon-loading">
        <mtable
          v-if="trData"
          :thData="thData"
          :trData="trData"
          :multiLanguage="CPACommDetailLan"
          :jsonExcelAjax="jsonExcelAjax"
          :downLoadTran="downLoadTran"
          :name="name"
        >
          <div slot="handle" class="cpa-detail">
            <div class="cpa-detail">
              <span>{{CPACommDetailLan.proxyAccount}}&nbsp;{{queryObj.IB_ID}}</span>
            </div>
            <div class="cpa-detail">
              <span>{{CPACommDetailLan.commissionType}}&nbsp;{{CPACommDetailLan.type}}</span>
            </div>
          </div>
        </mtable>
      </div>
    </div>
  </div>
</template>
<script>
import mtable from "../../comm/mytable";
import { Api } from "api/commissionEnv";
import { URL_CPADETAIL } from "api/commissionApi";
let api = new Api();

export default {
  name: "CPAMonthlyCommDetailResult",
  mixins: [
    require("common/mixin/base.js").base({ CPACommDetailLan: "cpaIBResult" })
  ],
  props: ["curArea"],
  data() {
    return {
      trData: [],
      queryObj: {},
      area: [],
      url: "",
      loading: true
    };
  },
  computed: {
    thData() {
      return this.CPACommDetailLan.detailTh;
    },
    name() {
      return this.CPACommDetailLan.datailText;
    },
    downLoadTran() {
      return { IB_ID: this.CPACommDetailLan.total };
    },
    jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: "get",
        getKey: ["data", "data"],
        rID: this.queryObj.REPORT_ID,
        cID: this.queryObj.IB_ID,
        ajaxPar: {
          lang: this.LANGUAGE,
          ib_id: this.queryObj.IB_ID,
          report_id: this.queryObj.REPORT_ID
        }
      };
    }
  },
  mounted() {
    this.area = JSON.parse(sessionStorage.getItem("area")).GM;
    this.queryObj = this.$route.query;
    this.tableAjax();
  },
  methods: {
    tableAjax() {
      this.loading = true;
      this.url = api.getUrl20(this.curArea, URL_CPADETAIL)
      let tableObj = {
        params: {
          ib_id: this.queryObj.IB_ID,
          report_id: this.queryObj.REPORT_ID
        }
      };
      this.$http.get(this.url, tableObj).then(res => {
        this.trData = res.data.data;
        this.setOfficeState();
        this.loading = false;
      });
    },
    setOfficeState() {
      let list = this.CPACommDetailLan.total;
      if (Object.prototype.toString.call(this.trData) == "[object Array]") {
        this.trData.forEach((item, index) => {
          let temp = this.trData[index];
          if (index === this.trData.length - 1) temp.ib_id = list[temp.IB_ID];
          else temp.ib_id = temp.IB_ID;
        });
      }
    }
  },
  watch: {
    CPACommDetailLan() {
      this.setOfficeState();
    },
    curArea() {
      if (this.area.indexOf(this.curArea) > -1) this.$router.push("ibSetting");
      else this.$router.push("/ib/CPACommissionResult");
    }
  },
  components: {
    mtable
  }
};
</script>
<style lang="scss" type="text/scss" scoped>
.title-box {
  border: 1px solid #3f51b5;
  background: #3f51b5;
  padding: 0 20px;
  color: #fff;
  border-radius: 5px 5px 0 0;
  .preview-btn {
    border: 1px solid #f08712;
    background-color: #f08712;
    border-radius: 5px;
  }
}
.cpa-detail {
  float: left;
  margin-right: 50px;
}
</style>



// WEBPACK FOOTER //
// CPAMonthlyCommDetailResult.vue?f194e6c4